import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { IUser } from '@shs-digi-care-monorepo/interfaces';
import packageJson from 'package.json';
import { ContactDialog } from './components/contact-dialog/contact-dialog.component';
import { BaseHeaderComponent } from '@shs-digi-care-monorepo/frontend-lib/components';
import { UserState } from '@shs-digi-care-monorepo/frontend-lib/states';
import { SettingsMenuComponent } from './components/settings-menu/settings-menu.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [TranslateModule, RouterModule, BaseHeaderComponent, SettingsMenuComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent {
    private dialog = inject(MatDialog);

    protected version = packageJson.version;
    protected me: Signal<IUser | null> = select(UserState.me);
    protected isAdmin: Signal<boolean> = select(UserState.isAdmin);
    protected isInternalUser: Signal<boolean> = select(UserState.isInternal);

    protected userName = computed(() => {
        const user = this.me();
        return user ? `${user.firstName} ${user.lastName}` : null;
    });

    protected userInfo = computed(() => {
        const user = this.me();
        return user?.roles ? user.roles.join(', ') : '';
    });

    protected userInitials = computed(() => {
        const user = this.me();
        return user ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}` : null;
    });

    public openContactDialog(): void {
        this.dialog.open(ContactDialog);
    }
}
